<template>
	<label class="label" v-if="hasValueProp" v-html="value"></label>
	<label class="label" v-else-if="hasSlotData">
		<slot></slot>
	</label>
</template>

<script>
export default {
	name: 'LabelField',
	props: {
		value: {}
	},
	computed: {
		hasValueProp: function() {
			return this.value && this.value.length;
		},
		hasSlotData() {
			return this.$slots.default;
		}
	},
	mounted: function() {
	},
	methods: {
	}
}
</script>

<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".label";
	#{$c}
	{
	}
</style>



// WEBPACK FOOTER //
// src/components/atoms/LabelField.vue